var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWalletCloseEye = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/eye"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.5 7.5C6.52689 11.6886 14.708 11.6861 17.5 7.5M8.77086 11.0188L7.95468 13.3333M5.01021 10.315L3.18215 11.8983M12.0455 11.0188L12.8616 13.3333M15.4545 10.315L17.2826 11.8983",
    stroke: "#73756D",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWalletCloseEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wallet_close_eye.1d6cac89c337986114b587548ab72881.svg";